import { render } from "./schedule-friday.vue?vue&type=template&id=6bbd71a6"
import script from "./schedule-friday.vue?vue&type=script&lang=js"
export * from "./schedule-friday.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__